import { Grid } from "@mui/material";
import { useMediaQuery } from "@mui/system";
import { settings } from "app";
import React from "react";
import { FunctionField, Labeled, SimpleShowLayout, TextField } from "react-admin";
import { GenderOptionsId } from "utils/choices";
import { IdType, IdTypeName } from "utils/constants";

const PersonalData = ({ record }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <SimpleShowLayout>
      <Grid
        spacing={2}
        container
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Име">
            <TextField
              source="studentInfo.firstName"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Презиме">
            <TextField
              source="studentInfo.secondName"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Фамилия">
            <TextField
              source="studentInfo.lastName"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Факултетен номер">
            <TextField
              source="studentInfo.facultyNumber"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled
            label={
              record?.studentInfo?.personIdType === IdType.EGN
                ? IdTypeName.EGN
                : record?.studentInfo?.personIdType === IdType.PNF
                  ? IdTypeName.PNF
                  : IdTypeName.PID
            }
          >
            <TextField
              source="studentInfo.personId"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Пол">
            <FunctionField
              render={record => GenderOptionsId.find(option => option.id === record?.studentInfo?.gender)?.name}
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Телефон">
            <TextField
              source="studentInfo.contactPhone"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Имейл">
            <TextField
              source="studentInfo.email"
              emptyText="-"
            />
          </Labeled>
        </Grid>
      </Grid>
    </SimpleShowLayout>
  );
};

export default PersonalData;
